/* 🤖 this file was generated by svg-to-ts */
export const myIconStar: {
  name: 'star';
  data: string;
} = {
  name: 'star',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path fill="currentColor" d="m196-28 75-324L19-570l332-28 129-306 129 306 332 28-252 218 76 324-285-173L196-28Z"/></svg>`,
};
